<template>
  <section class="asset-wrapper main-container search text-center pt-10 pb-20 mx-auto">
    <div class="text-left mt-10">
      <AssetComponent />
    </div>
  </section>
</template>

<script>
import AssetComponent from '@/components/common/AssetComponent';

export default {
  name: 'AssetWrapper',
  components: {
    AssetComponent,
  },
};
</script>

<style scoped>
.asset-wrapper {
  max-width: 90vw;
  min-height: calc(100vh - 270px);
}
</style>